import { SvbrgIntakeStatus } from '@/generated/gql/graphql';

export enum GridActionType {
  DISCARD = 'discard',
  CANCEL = 'cancel',
}

export const STATUS_GRID_ACTION_MAP: Record<SvbrgIntakeStatus, GridActionType | null> = {
  [SvbrgIntakeStatus.DRAFT]: GridActionType.DISCARD,
  [SvbrgIntakeStatus.CANCELLED]: GridActionType.DISCARD,
  [SvbrgIntakeStatus.IN_PROGRESS]: GridActionType.CANCEL,
  [SvbrgIntakeStatus.RELEASED]: GridActionType.CANCEL,
  [SvbrgIntakeStatus.BLOCKED]: GridActionType.CANCEL,
  [SvbrgIntakeStatus.COMPLETED]: null,
};
